module.exports = __webpack_public_path__ + "img/CH_Phone.014eeaeb.png";